export { default } from './DownloadButton';



// WEBPACK FOOTER //
// ./src/components/atoms/DownloadButton/index.js